import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FirstTableAi from "./FirstTableAi/FirstTableAi";
import SecondTableAi from "./SecondTableAi/SecondTableAi";
import { useSelector } from "react-redux";
import StAiRecFilterCard from "./StAiRecFilterCard";
import { useSearchParams } from "react-router-dom";
import {
  clearFirstTableState,
  clearSecondTableState,
} from "../../../../../../../../features/aiRecomendationTabSlice";
import { useDispatch } from "react-redux";
import StLevelFilterCard from "./STLevelFilterCard";

const StoAIRecomondation = () => {
  // state to track which accordion is expanded
  const [expanded, setExpanded] = useState<string | false>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);

      // Clear state when accordion is closed
      if (!isExpanded) {
        dispatch(clearFirstTableState());
        dispatch(clearSecondTableState());
      }

      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        const prevAccordion = params.get("accordion");
        if (!isExpanded || prevAccordion !== panel) {
          dispatch(clearFirstTableState());
          dispatch(clearSecondTableState());
        }
        if (isExpanded) {
          params.set("accordion", panel);
        } else {
          params.delete("accordion");
          params.delete("filters");
        }

        return params;
      });
    };

  const { allAIRecomendation, allSTLevels } = useSelector(
    (state: any) => state.aiRecomandationTab
  );

  return (
    <Box p={2}>
      {/* Preforming Search Terms Without Classification – 59   */}
      <Accordion
        expanded={
          expanded === "panel1" || searchParams.get("accordion") === "panel1"
        }
        onChange={handleChange("panel1")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            minHeight: "48px !important",
          }}
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Keyword Level – {allAIRecomendation.length}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <StAiRecFilterCard />
          <FirstTableAi />
        </AccordionDetails>
      </Accordion>
      {/* Exclusive Search Terms Missing Cross-Negatives – 10 */}
      <Accordion
        expanded={
          expanded === "panel2" || searchParams.get("accordion") === "panel2"
        }
        onChange={handleChange("panel2")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Search Term Level– {allSTLevels.length}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <StLevelFilterCard />
          <SecondTableAi />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default StoAIRecomondation;
